// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.jqwo12BDleqnjA {
  padding: 96px 0;
  text-align: center;
}
.jqwo12BDleqnjA .dFN0TPWFDwcC7a {
  margin-bottom: 16px;
}
.jqwo12BDleqnjA .mAIBqk0ksAnw_h {
  max-width: 300px;
  margin: 0 auto;
  opacity: 0.5;
  color: var(--ds-text-subtle, #44546f);
  font-size: 16px;
  text-align: center;
}
.FNZb9GbMdUz0YH,
.jqwo12BDleqnjA {
  border-top: 1px solid var(--ds-border, #091e4224);
}
`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"orgMembersMissingContainer": `jqwo12BDleqnjA`,
	"orgMembersMissingIllustration": `dFN0TPWFDwcC7a`,
	"orgMembersContent": `mAIBqk0ksAnw_h`,
	"orgMembersList": `FNZb9GbMdUz0YH`
};
export default ___CSS_LOADER_EXPORT___;
